
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/store/products",
      function () {
        return require("private-next-pages/[ssgParams]/store/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/store/products"])
      });
    }
  